import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';

export const Root = styled('div')<{ isNativePlatform?: boolean }>(
	({ theme, isNativePlatform }) => ({
		backgroundColor: theme.palette.neutral[0],
		width: '100%',
		height: '100%',
		display: 'grid',
		gridTemplateRows: isNativePlatform
			? 'max-content 1fr max-content'
			: 'max-content 1fr',
		maxWidth: MOBILE_CONTAINER_WIDTH,
		margin: 'auto',
		...(!isNativePlatform && { boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px' }),
	})
);

export const Block = styled('div')(() => ({
	width: '100%',
	height: '100%',
	overflowY: 'auto',
}));
